import React, { useState, useEffect } from "react";
import CountedInput from "./CountedInput";
import { motion } from "framer-motion";
type Props = {
  label: string;
  children?: React.ReactNode;
  cols: number;
  inp: any;
  filledInputs: any;
};

const InputCluster = ({ label, cols, children, inp, filledInputs }: Props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    for (let i = 0; i < inp.fields.length; i++) {
      if (filledInputs && filledInputs[inp?.fields[i].name]) {
        setOpen(true);
      }
    }
  }, []);

  return (
    <>
      <div
        onClick={() => {
          setOpen(!open);
        }}
        className="h-px my-10 bg-natural-grey-400 flex items-center cursor-pointer"
      >
        <span className="text-sm bg-white pl-1 pr-4 font-semibold">
          <input
            type="checkbox"
            onClick={() => {
              setOpen(!open);
            }}
            className="checked:bg-primary-500 rounded-sm"
            defaultChecked={open}
          />
          <p className="ml-2 inline-block font-medium text-tootler-grey-600">
            {label}
          </p>
        </span>
      </div>
      <motion.div
        initial={{
          height: 0,
          overflow: "hidden",
          opacity: 0,
        }}
        animate={{
          height: open ? "auto" : 0,
          overflow: "hidden",
          opacity: 1,
        }}
        className={`mb-5 grid gap-4 grid-cols-${cols}`}
      >
        {children}
      </motion.div>
    </>
  );
};

export default InputCluster;
